import {
  STORE_APPLE_DATA
} from '../../constants/actions';

export function storeAppleData (data) {
  return {
    type: STORE_APPLE_DATA,
    data
  };
}
